import get from './getField'

export default function (obj) {
  if (obj === null || obj === undefined) {
    return null
  }
  if (arguments.length < 2) {
    return JSON.stringify(obj)
  }
  let searchValues = new Set()
  for (let i = 1; i < arguments.length; i++) {
    let value = get(obj, arguments[i])
    if (value !== null && value !== undefined) {
      searchValues.add(('' + value).trim().toLowerCase())
    }
  }
  return Array.from(searchValues).join(' ')
}



// WEBPACK FOOTER //
// ./src/utils/createSearchString.js